import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function BlogNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigateWithHash = (hash: string) => {
    if (location.pathname === '/') {
      // Já está na home, apenas rolar
      const element = document.getElementById(hash);
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      // Navegar para home com hash
      navigate(`/#${hash}`);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-stone-900'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => navigate('/')}
            className={`text-2xl font-bold transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            IBX Brasil
          </button>

          <div className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => handleNavigateWithHash('sobre')}
              className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-gray-300'
              }`}
            >
              Sobre Nós
            </button>
            <button
              onClick={() => handleNavigateWithHash('servicos')}
              className={`text-sm font-medium transition-colors hover:text-orange-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-gray-300'
              }`}
            >
              Serviços
            </button>
            <button
              onClick={() => navigate('/blog')}
              className="text-sm font-medium text-orange-500 whitespace-nowrap cursor-pointer"
            >
              Blog
            </button>
            <button
              onClick={() => handleNavigateWithHash('contato')}
              className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Fale Conosco
            </button>
          </div>

          <button
            onClick={() => navigate('/')}
            className={`lg:hidden text-sm font-medium flex items-center gap-1.5 cursor-pointer whitespace-nowrap ${
              isScrolled ? 'text-gray-700' : 'text-gray-300'
            }`}
          >
            <i className="ri-arrow-left-line"></i> Voltar ao site
          </button>
        </div>
      </div>
    </nav>
  );
}